export default __webpack_public_path__ + "static/media/claim.f1dbdeb6.svg";